import React, {useEffect, useRef, useState} from 'react';
import cx from 'classnames';

import {LLSportBettingButtonWrapper} from "../../../../../components";


export const PlayersMarketRowDesktop = ({item}) => {
    const
        [showArrows, setShowArrows] = useState(false),
        [scrollLeft, setScrollLeft] = useState(0);

    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current?.scrollWidth > contentRef.current?.offsetWidth) {
            setShowArrows(true);
            let timeout = null;
            const handleScroll = (e) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    setScrollLeft(e.target?.scrollLeft);
                }, 200)
            };
            contentRef.current?.addEventListener('scroll', handleScroll, {passive: true});
            return () => contentRef.current?.removeEventListener('scroll', handleScroll);
        }
    }, []);

    const scroll = (direction) => {
        requestAnimationFrame(() =>
            contentRef.current?.scrollTo({
                left: contentRef.current?.scrollLeft + (direction === 'right' ? 200 : -200),
                behavior: 'smooth'
            })
        );
    }

    const isLeftArrowDisabled = scrollLeft < 1;
    const isRightArrowDisabled = scrollLeft + contentRef.current?.offsetWidth > contentRef.current?.scrollWidth - 1;

    return (
        <div
            className="match-player-market__bets"
            key={item.id + item.replacedSpecifier}
        >
            <div className="match-player-market__bets-content" ref={contentRef}>
                {item.betRowsList.map(row => row.bets.map(bet => bet ?
                    <LLSportBettingButtonWrapper
                        bet={bet}
                        key={bet?.id}
                        withShortName={true}
                        className="match-details__bet"
                    /> : null
                ))}
            </div>
            { showArrows && (
                <div className="match-player-market__bets-arrows">
                    <i className={cx(
                        'match-player-market__bets-arrow',
                        'match-player-market__bets-arrow--left',
                        'doruk-mg-arrow-2',
                        isLeftArrowDisabled && 'disabled'
                    )}
                       onClick={() => {
                           if (!isLeftArrowDisabled) {
                               scroll('left');
                           }
                       }}
                    />
                    <i className={cx(
                        'match-player-market__bets-arrow',
                        'match-player-market__bets-arrow--right',
                        'doruk-mg-arrow-2',
                        isRightArrowDisabled && 'disabled'
                    )}
                       onClick={() => {
                           if (!isRightArrowDisabled) {
                               scroll('right');
                           }
                       }}
                    />
                </div>
            )}
        </div>
    );
}